import { InternMap } from "d3-array";
import { initRange } from "./init.js";
export var implicit = Symbol("implicit");
export default function ordinal() {
    var index = new InternMap(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        var i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit)
                return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function (_) {
        if (!arguments.length)
            return domain.slice();
        domain = [], index = new InternMap();
        for (var _i = 0, _1 = _; _i < _1.length; _i++) {
            var value = _1[_i];
            if (index.has(value))
                continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function (_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function (_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function () {
        return ordinal(domain, range).unknown(unknown);
    };
    initRange.apply(scale, arguments);
    return scale;
}
